//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  methods: {
    toPath(path) {
      this.$router.push(path);
    },
     toPath1(path) {
    if( this.$common.getCookie('_token')){
     
    } else{
       this.$router.push(path);
    } 
     
    }
  },
  mounted() {},
  created() {},
  props: {},
  watch: {},
  components: {}
};



// WEBPACK FOOTER //
// ./src/views/activity/activity.vue